import SubmissionSection from "@container/asess-section/list-submission";
import AuthLayout from "@container/layout/auth";

export default function EmployerSubmissionPage() {
    return (
        <AuthLayout>
            <SubmissionSection />
        </AuthLayout>
    );
}
